/**
 * @generated SignedSource<<58dd46f6176273185c63451ebddbf421>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation$variables = {
  marketingAccepted: boolean;
};
export type useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation$data = {
  readonly acceptTermsAndConditions: boolean;
};
export type useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation = {
  response: useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation$data;
  variables: useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "marketingAccepted"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "marketingAccepted",
        "variableName": "marketingAccepted"
      }
    ],
    "kind": "ScalarField",
    "name": "acceptTermsAndConditions",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "f9d196192d078bc97caeaaae2d839790",
    "id": null,
    "metadata": {},
    "name": "useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation",
    "operationKind": "mutation",
    "text": "mutation useShouldAcceptTermsAndConditionsDialogAcceptTermsAndConditionsMutation(\n  $marketingAccepted: Boolean!\n) {\n  acceptTermsAndConditions(marketingAccepted: $marketingAccepted)\n}\n"
  }
};
})();

(node as any).hash = "6aaee117bfcf214a8df93afdc56d26b7";

export default node;
